<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>CRÉDITOS</h2>
    <h3>Universidad Popular Autónoma del Estado de Puebla</h3>
    <p>
      <b>Emilio José Baños Ardavín</b><br>
      Rector<br><br>
      <b>Mariano Sánchez Cuevas</b><br>
      Vicerrector Académico<br><br>
      <b>Francisco Eugenio Urrutia Albisua</b><br>
      Vicerrector de Investigación<br><br>
      <b>Luis Fernando Roldán de la Tejera</b><br>
      Director de Formación, Cultura y Liderazgo
    </p>
    <h3>Museo UPAEP</h3>
    <p>
      <b>Evelin Flores Rueda</b><br>
      Dirección<br><br>
      <b>Mariana Cruz Ugarte</b><br>
      Coordinación de Comunicación Educativa<br><br>
      <b>Rodrigo Rojano Robledo</b><br>
      Coordinación de Colecciones<br><br>
      <b>Tere Itzel Alva Juárez</b><br>
      Coordinación de Mercadotecnia y Relaciones Públicas<br><br>
      <b>Lourdes Gómez Mendoza</b><br>
      Mediadora<br><br>
      <b>Ricardo González Zacarías</b><br>
      Servicios Generales
    </p>
    <h3>Museo Nacional de Historia “Castillo de Chapultepec”</h3>
    <p>
      <b>Salvador Rueda Smithers</b><br>
      Director<br><br>
      <b>Erandi Rubio Huertas</b><br>
      Subdirección Técnica
    </p>
    <h3>Curaduría</h3>
    <p>
      <b>David Sánchez Sánchez</b><br>
      Director de la Facultad en Humanidades y Gestión Cultural UPAEP<br><br>
      <b>Evelin Flores Rueda</b><br>
      Directora del Museo UPAEP
    </p>
    <h3>Diseño de la interfaz</h3>
    <p>
      <b>Rodrigo Rojano Robledo</b><br>
      Diseño de la museografía y renderización del espacio virtual<br><br>
      <b>Nadxieeli Fuentes Ríos</b><br>
      Diseño de la identidad gráfica 
    </p>
    <h3>Producción Audiovisual</h3>
    <p>
      <b>Juan Carlos Gazca Muñoz</b><br>
      <b>Mariana Cruz Ugarte</b><br>
      <b>Tessa Fernanda Pérez Aguilar</b><br>
      Voz en off<br><br>
      <b>Mariana Cruz Ugarte</b><br>
      <b>Tessa Fernanda Pérez Aguilar</b><br>
      Video bienvenida<br><br>
      <b>Mariana Cruz Ugarte</b><br>
      Traducción inglés<br><br>
      <b>Raymundo Hernández González</b><br>
      Mapas animados<br><br>
      <b>Tere Itzel Alva Juárez</b><br>
      <b>Jorge Enrique Pérez Osio</b><br>
      Producción audiovisual<br><br>
      <b>Adriana Rendón González</b><br>
      Traducción de Español a la Lengua de Señas Mexicana<br><br>
      <b>Alba Selene Arenas León</b><br>
      Intérprete de Lengua de Señas Mexicana
    </p>
    <h3>Colaboraciones Especiales</h3>
    <p>
      <b>Eduardo Merlo Juárez</b><br>
      Asesor Cultural UPAEP<br><br>
      EDIS Interactive <br>
      UPRESS<br>
      IDD UPAEP<br>
      Dirección de Educación Especial de la Secretaría de Educación Pública del Estado de Puebla <br>
    </p>
  </div>
</template>

<script>
export default {
  name: "s31g01",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
